// extracted by mini-css-extract-plugin
export default {"radio":"radio-EkpYd","subsection":"subsection-cuuO5"};